"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const components_2 = require("../components");
const forms_1 = require("../forms");
const DetailsCollapse_1 = __importDefault(require("./DetailsCollapse"));
function StoreInformationContainer({ canSubmit = null, enrollmentData, setMarkedCompleteOrSkipped, createProposedEnrollmentDataChanges, updateProposedEnrollmentDataChanges, getProposedEnrollmentDataChanges, index, singleDisplay, keepHeader = false, allowEdit = true, refreshPage = () => { }, changesList = null, isNewDeal = false, hasEnrollments = false, }) {
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    // State
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [completeStatus, setCompleteStatus] = (0, react_1.useState)('incomplete');
    const [isEditMode, setIsEditMode] = (0, react_1.useState)(false);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [originalValues, setOriginalValues] = (0, react_1.useState)(null);
    const [currentEnrollmentData, setCurrentEnrollmentData] = (0, react_1.useState)({
        practiceName: enrollmentData.metadata?.practiceName ?? '',
        federalTaxId: enrollmentData.metadata?.federalTaxId ?? '',
        legalBusinessName: enrollmentData.metadata?.legalBusinessName ?? '',
        legalEntityType: enrollmentData.metadata?.legalEntityType ?? '',
        routingNumber: enrollmentData.metadata?.routingNumber ?? '',
        accountNumber: enrollmentData.metadata?.accountNumber ?? '',
        bankName: enrollmentData.metadata?.bankName ?? '',
        status: '',
    });
    const [proposedChanges, setProposedChanges] = (0, react_1.useState)(null);
    const determineChanges = (changes, originalValues) => {
        const diffChanges = {};
        for (const key in changes) {
            if (changes[key] !== originalValues[key]) {
                diffChanges[key] = changes[key];
            }
        }
        if (changes.legalEntityType != originalValues.incorporationType) {
            diffChanges.legalEntityType = changes.legalEntityType;
        }
        else {
            delete diffChanges.legalEntityType;
        }
        if (changes.address && originalValues.address) {
            let addressChanged = false;
            for (const key in changes.address) {
                if (changes.address[key] !== originalValues.address[key]) {
                    addressChanged = true;
                }
            }
            if (addressChanged) {
                diffChanges.address = changes.address;
            }
            else {
                delete diffChanges.address;
            }
        }
        return diffChanges;
    };
    const rerouteToDocUploadIfNeeded = (changes) => {
        if (!isNewDeal &&
            Object.keys(changes).some((element) => element === 'routingNumber' ||
                element === 'accountNumber' ||
                element === 'federalTaxId' ||
                element === 'legalBusinessName')) {
            history.push({ pathname: config_1.DOCUMENT_MANAGEMENT_URL });
        }
    };
    const getProposedEnrollmentData = async (enrollmentData) => {
        await getProposedEnrollmentDataChanges(enrollmentData.locationId).then((response) => {
            if (!!response.length) {
                setCurrentEnrollmentData({
                    proposedChangeId: response[0].id,
                    practiceName: response[0]?.practiceName
                        ? response[0].practiceName
                        : enrollmentData.metadata.practiceName,
                    federalTaxId: response[0].federalTaxId,
                    legalBusinessName: response[0].legalBusinessName,
                    legalEntityType: response[0].legalEntityType,
                    routingNumber: response[0].routingNumber,
                    accountNumber: response[0].accountNumber,
                    status: response[0].status,
                    phone: response[0].phone,
                    bankName: response[0].bankName,
                    address: {
                        street1: response[0].address?.street1,
                        street2: response[0].address?.street2,
                        city: response[0].address?.city,
                        state: response[0].address?.state,
                        zip: response[0].address?.zip,
                    },
                });
                setProposedChanges({
                    proposedChangeId: response[0].id,
                    practiceName: response[0]?.practiceName
                        ? response[0].practiceName
                        : enrollmentData.metadata.practiceName,
                    federalTaxId: response[0].federalTaxId,
                    legalBusinessName: response[0].legalBusinessName,
                    legalEntityType: response[0].legalEntityType,
                    routingNumber: response[0].routingNumber,
                    accountNumber: response[0].accountNumber,
                    status: response[0].status,
                    phone: response[0].phone,
                    bankName: response[0].bankName,
                    address: {
                        street1: response[0].address?.street1,
                        street2: response[0].address?.street2,
                        city: response[0].address?.city,
                        state: response[0].address?.state,
                        zip: response[0].address?.zip,
                    },
                });
            }
        });
    };
    (0, react_1.useEffect)(() => {
        getProposedEnrollmentData(enrollmentData);
        setOriginalValues({
            practiceName: enrollmentData.metadata.practiceName,
            legalBusinessName: enrollmentData.metadata.legalBusinessName,
            federalTaxId: enrollmentData.metadata.federalTaxId,
            routingNumber: enrollmentData.metadata.routingNumber,
            accountNumber: enrollmentData.metadata.accountNumber,
            legalEntityType: enrollmentData.metadata.legalEntityType,
            incorporationType: enrollmentData.metadata.legalEntityType,
            address: {
                street1: enrollmentData.address?.street1,
                street2: enrollmentData.address?.street2,
                city: enrollmentData.address?.city,
                state: enrollmentData.address?.state,
                zip: enrollmentData.address?.zip,
            },
            phone: enrollmentData.phone,
            bankName: enrollmentData.metadata.bankName,
            status: '',
        });
    }, [enrollmentData]);
    const handleSkip = () => {
        setMarkedCompleteOrSkipped((prev) => {
            return { ...prev, [enrollmentData.locationId]: 'skipped' };
        });
        setCompleteStatus('skipped');
        setIsExpanded(false);
    };
    const handleComplete = () => {
        setMarkedCompleteOrSkipped((prev) => {
            return { ...prev, [enrollmentData.locationId]: 'marked_as_completed' };
        });
        setCompleteStatus('completed');
        setIsExpanded(false);
    };
    const handleSubmitChanges = async (changes, originalValues) => {
        setSubmitting(true);
        const previousChanges = JSON.parse(JSON.stringify(currentEnrollmentData));
        setCurrentEnrollmentData({ ...currentEnrollmentData, ...changes });
        const diffChanges = determineChanges(changes, originalValues);
        const response = await getProposedEnrollmentDataChanges(enrollmentData.locationId);
        if (response.length) {
            const originalValuesString = JSON.stringify({
                practiceName: originalValues.practiceName,
                legalBusinessName: originalValues.legalBusinessName,
                federalTaxId: originalValues.federalTaxId,
                routingNumber: originalValues.routingNumber,
                accountNumber: originalValues.accountNumber,
            });
            const responseString = JSON.stringify({
                practiceName: response[0].practiceName,
                legalBusinessName: response[0].legalBusinessName,
                federalTaxId: response[0].federalTaxId,
                routingNumber: response[0].routingNumber,
                accountNumber: response[0].accountNumber,
            });
            if (originalValuesString !== responseString) {
                (0, utils_1.toastError)("Changes have been made since you've started editing, please review the changes and update if you still want to make changes.");
            }
        }
        if (currentEnrollmentData.status &&
            currentEnrollmentData.proposedChangeId) {
            // Patch
            try {
                await updateProposedEnrollmentDataChanges(enrollmentData.locationId, currentEnrollmentData.proposedChangeId, {
                    status: 'created',
                    changes: diffChanges,
                });
                await getProposedEnrollmentData(enrollmentData);
                (0, utils_1.toastSuccess)('Changes saved successfully', 3000);
                setSubmitting(false);
                // Stay on Page
                setIsEditMode(false);
                // If docs needed on location management, reroute to doc upload
                rerouteToDocUploadIfNeeded(diffChanges);
                if (refreshPage) {
                    refreshPage();
                }
            }
            catch (error) {
                (0, utils_1.toastError)(`Failed to save changes`);
                setCurrentEnrollmentData(previousChanges);
                setSubmitting(false);
            }
        }
        else {
            // Post
            try {
                await createProposedEnrollmentDataChanges(enrollmentData.locationId, {
                    status: 'created',
                    changes: diffChanges,
                });
                await getProposedEnrollmentData(enrollmentData);
                (0, utils_1.toastSuccess)('Changes saved successfully', 3000);
                setSubmitting(false);
                setIsEditMode(false);
                // If docs needed on location management, reroute to doc upload
                rerouteToDocUploadIfNeeded(diffChanges);
                // Refresh page data
                if (refreshPage) {
                    refreshPage();
                }
            }
            catch (error) {
                (0, utils_1.toastError)(`Failed to save changes`, 8000);
                setSubmitting(false);
            }
        }
    };
    const handleEditInformation = () => {
        setIsEditMode(!isEditMode);
    };
    const handleCompleteMgmt = async (fileNeeded) => {
        if (fileNeeded) {
            history.push({ pathname: config_1.DOCUMENT_MANAGEMENT_URL });
        }
        else {
            setSubmitting(true);
            // PATCH
            if (currentEnrollmentData && currentEnrollmentData.proposedChangeId) {
                const changes = determineChanges(currentEnrollmentData, originalValues);
                try {
                    await updateProposedEnrollmentDataChanges(enrollmentData.locationId, currentEnrollmentData.proposedChangeId, {
                        status: 'pending_review',
                        changes: {
                            ...changes,
                            status: undefined,
                            proposedChangeId: undefined,
                            files: undefined,
                        },
                    });
                    (0, utils_1.toastSuccess)(`Successfully submitted changes for review`, 8000);
                    // Refresh page data
                    if (refreshPage) {
                        refreshPage();
                    }
                }
                catch (error) {
                    (0, utils_1.toastError)(`Failed to save changes`, 8000);
                }
                finally {
                    setSubmitting(false);
                }
            }
        }
    };
    const isInPendingReview = (0, react_1.useMemo)(() => {
        return (changesList &&
            changesList[0] &&
            changesList[0].status === 'pending_review');
    }, [changesList]);
    return ((0, jsx_runtime_1.jsx)(DetailsCollapse_1.default, { isExpanded: isExpanded || singleDisplay, setIsExpanded: setIsExpanded, index: index, completeStatus: completeStatus, practiceName: currentEnrollmentData.practiceName, singleDisplay: singleDisplay, keepHeader: keepHeader, children: isExpanded ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isEditMode ? ((0, jsx_runtime_1.jsx)(forms_1.StoreInformationForm, { handleEditInformation: handleEditInformation, adsStoreNumber: enrollmentData.adsStoreNumber, practiceName: currentEnrollmentData.practiceName, legalBusinessName: currentEnrollmentData.legalBusinessName, federalTaxId: (0, utils_1.addHyphen)(currentEnrollmentData.federalTaxId), routingNumber: currentEnrollmentData.routingNumber, accountNumber: currentEnrollmentData.accountNumber, keepHeader: keepHeader, bankName: currentEnrollmentData.bankName, enrollmentData: enrollmentData, currentEnrollmentData: currentEnrollmentData, handleSubmitChanges: handleSubmitChanges, submitting: submitting, index: index })) : ((0, jsx_runtime_1.jsx)(components_2.StoreInformationDisplay, { enrollmentData: enrollmentData, proposedChanges: proposedChanges, handleEditInformation: handleEditInformation, practiceName: currentEnrollmentData.practiceName, legalBusinessName: currentEnrollmentData.legalBusinessName, federalTaxId: (0, utils_1.addHyphen)(currentEnrollmentData.federalTaxId), routingNumber: currentEnrollmentData.routingNumber, accountNumber: currentEnrollmentData.accountNumber, adsStoreNumber: enrollmentData.adsStoreNumber, keepHeader: keepHeader, bankName: currentEnrollmentData.bankName, completeStatus: completeStatus, index: index, hasEnrollments: hasEnrollments, allowEdit: (allowEdit || !!changesList?.length) &&
                        !isInPendingReview &&
                        enrollmentData.isCurrentLocationManagerSigner })), ((changesList && changesList?.length > 0) || proposedChanges) && ((0, jsx_runtime_1.jsx)("div", { className: "store-information-review-info", children: singleDisplay && isInPendingReview ? ((0, jsx_runtime_1.jsx)(components_1.P, { children: "* Your provided documentation is currently under review. Until these updates are validated by Alphaeon Credit, the original information will continue to be used. Please wait for Alphaeon to approve the documents you uploaded." })) : ((0, jsx_runtime_1.jsxs)(components_1.P, { children: [' ', "* Please note that documentation may be required to validate the updated information. Until these updates are validated by Alphaeon Credit, the original information will continue to be used."] })) })), (0, jsx_runtime_1.jsx)("div", { children: singleDisplay && !keepHeader ? ((0, jsx_runtime_1.jsx)("div", { children: isEditMode ||
                            !enrollmentData.isCurrentLocationManagerSigner ? null : ((0, jsx_runtime_1.jsx)("div", { className: "complete-or-skip flex-dir-col", children: !isInPendingReview && ((0, jsx_runtime_1.jsx)(components_1.Button, { disabled: !!!changesList?.length || !canSubmit, type: "submit", submitting: submitting, className: "btn-legacy button-warn mark-complete", onClick: () => handleCompleteMgmt(false), "data-testid": `update-info-mark-complete-button-${index}`, children: "SUBMIT" })) })) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: completeStatus !== 'completed' && !isEditMode && ((0, jsx_runtime_1.jsxs)("div", { className: "complete-or-skip", children: [(0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", className: "button-warn mark-complete", onClick: handleComplete, "data-testid": `update-info-mark-complete-button-${index}`, children: "THIS LOCATION INFO IS CORRECT" }), !singleDisplay && ((0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", className: "button-warn-outline skip", onClick: handleSkip, "data-testid": `update-info-skip-button-${index}`, children: "SKIP" }))] })) })) })] })) : null }));
}
function mapStateToProps() {
    return {};
}
const mapApiAuthToProps = {
    // getBankName: apiActions.getBankName,
    createProposedEnrollmentDataChanges: apiActions.createProposedEnrollmentDataChanges,
    updateProposedEnrollmentDataChanges: apiActions.updateProposedEnrollmentDataChanges,
    getProposedEnrollmentDataChanges: apiActions.getProposedEnrollmentDataChanges,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(StoreInformationContainer);
